import React, { useEffect, useState } from 'react'

// Components
import Modal from '../util/modal/Modal'
import Field from '../util/field/Field'
import NoItems from '../util/noitems/NoItems'
import Loading from '../util/loading/Loading'
import { toast } from 'react-toastify'
import ErrorMessages from '../../util/validation-error-messages'
import ReactExport from "react-export-excel-fixed-xlsx";

// Services
import Pagination from '../util/pagination/Pagination'
import WarehouseAPI from '../../services/Warehouse';
import InventoryItemsAPI from '../../services/InventoryItem';
import * as XLSX from "xlsx"

// Variable que indica el archivo de excel que se crea.
const ExcelFile = ReactExport.ExcelFile;
// Variable que indica una hoja de excel.
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
// Variable que indica una columna de excel.
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export const ModalArticulosBase = ({ onClose }) => {

    const [state, setState] = useState({
        articulosBase: [],
        pageArticulosBase: [],
        checkAll:false,
        childVisible:false,
        buttonMesagge:false,
        switchAllInv:false,
        switchAllSug:false,
        seeSwitchInv:false,
        seeSwitchSug:false,
        showUploadModal: false,
        excelData: [],
        isLoading: false,
        idCaffenio: 0,
        nombreArchivo: 'Cargar archivo Excel (.xlsx, .xls)...'
    })

    useEffect(() => {
        WarehouseAPI.ObtenerArticulosInventariosPlantilla()
        .then(response => {
            const articulosBaseAux = response.data
            setState(prev => ({ ...prev, articulosBase: articulosBaseAux }))
        }).catch(err => {
            setState(prev => ({ ...prev, isLoading: false }))
            if (err.response)
                toast.error(err.response.data)
            else
                toast.error(ErrorMessages.SinConexion)
        })
    },[])

    /**
     * Se ejecuta cada vez que el componente de paginación cambia de página.
     * Actualiza los artículos visibles (pageArticulosBase) y el estado de “check all”.
     */
    const handlePageChange = (items) => {
        const checkAllTemp = items.every(obj => obj.statusCheck)
        setState(prev => ({ ...prev,
            pageArticulosBase: items,
            checkAll: checkAllTemp
        }))
    }

    /* Cambiar el estado activo/inactivo para 'Sugestible' e 'Inventariable' */
    const ChangeStatus = (updatedItem) => {
        WarehouseAPI.SincronizarArticulosInventario([updatedItem]).then(response => {
            toast.success("Estatus actualizado")
            setState((prevState) => ({ ...prevState,
                pageArticulosBase: prevState.pageArticulosBase.map((item) =>
                item.idArticuloInventario === updatedItem.idArticuloInventario ? updatedItem : item ),

                articulosBase: prevState.articulosBase.map((item) =>
                item.idArticuloInventario === updatedItem.idArticuloInventario ? updatedItem : item ),
            }))
        }).catch(err => {
            setState(prev => ({ ...prev, isLoading: false }))
            if (err.response)
                toast.error(err.response.data)
            else
                toast.error(ErrorMessages.SinConexion)
        })
    }

    /* Funcion para cargar la plantilla excel  */
    const handleFileUpload = (event) => {
        // Capturamos el elemento input para poder limpiar su valor al final
        const inputElement = event.target
        setState(prev => ({ ...prev, isLoading: true, excelData: [], nombreArchivo: '' }))
        const file = inputElement.files && inputElement.files[0]
        if (!file) {
            setState(prev => ({ ...prev, isLoading: false, excelData: [], nombreArchivo: 'Cargar archivo Excel (.xlsx, .xls)...' }))
            // Limpiar el input para permitir reintentos
            try { if (inputElement) inputElement.value = '' } catch(e) {}
            return
        }

        const reader = new FileReader()

        // Nombre del archivo excel
        setState(prev => ({ ...prev, nombreArchivo: file.name }))
        
        reader.onload = async (e) => {
            const data = new Uint8Array(e.target.result)
            const workbook = XLSX.read(data, { type: "array" })
            const sheetName = workbook.SheetNames[0]
            const worksheet = workbook.Sheets[sheetName]
            let jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: null })

            // Limpiar espacios al inicio y al final de todos los valores tipo string
            jsonData = jsonData.map(row => {
                const cleanRow = {}
                for (const key in row) {
                    const value = row[key]
                    cleanRow[key] = typeof value === 'string' ? value.trim() : value
                }
                return cleanRow
            })

            const base = state.articulosBase || []

            // Crear sets para búsqueda rápida por CodigoProveedor
            const codigosBase = new Set(base.map(a => a.CodigoProveedor))
            const codigosExcel = new Set(jsonData.map(a => a.CodigoProveedor))

            // Detectar nuevos registros (aparecen en Excel pero no en Base)
            const nuevos = jsonData
                .filter(a => !codigosBase.has(a.CodigoProveedor))
                .map(a => ({
                    ...a,
                    IsNew: true,
                    IsDeleted: false,
                    Sugerible: a.Pedido ? a.Pedido : 0,
                    Inventariable: a.Inventario ? a.Inventario : 0,
                    idArticuloInventario: 0 // no tiene ID aún
                }))

            // Detectar eliminados (estaban en Base pero no en Excel)
            const eliminados = base
                .filter(a => !codigosExcel.has(a.CodigoProveedor))
                .map(a => ({
                    ...a,
                    IsNew: false,
                    IsDeleted: true,
                    idArticuloInventario: a.idArticuloInventario // mantener id original
                }))
                
            // Mantener los registros que siguen iguales
            const existentes = jsonData
                .filter(a => codigosBase.has(a.CodigoProveedor))
                .map(a => {
                    const articuloBase = base.find(function (b) {
                        return b.CodigoProveedor === a.CodigoProveedor
                    })
                    return {
                        ...a,
                        IsNew: false,
                        IsDeleted: false,
                        idArticuloInventario: articuloBase ? articuloBase.idArticuloInventario : 0,
                        Nombre: articuloBase ? articuloBase.Nombre : "",
                        NombreCorto: articuloBase ? articuloBase.NombreCorto : "",
                        Sugerible: (a.Pedido != null ? a.Pedido : (articuloBase ? articuloBase.Pedido : 0)),
                        Inventariable: (a.Inventario != null ? a.Inventario : (articuloBase ? articuloBase.Inventario : 0)),
                    }
            })
            
            // Se verifica que el CodigoProveedor exista en la bd
            let Agregar = [...nuevos]
            if(nuevos.length > 0)
            {
                try {
                    const response = await InventoryItemsAPI.VerificarExistenciaCodigoProveedor(nuevos)
                    const nuevoExisteBD = response.data || []

                    // Obtenemos solo los codigos que si existen
                    const codigosExistencia = new Set(nuevoExisteBD.map(b => b.CodigoProveedor))

                    // Obtenemos los codigos que NO existen para mostrarlos al usuario
                    let codigosSinExistencia = nuevos.filter(a => !codigosExistencia.has(a.CodigoProveedor))

                    // Mostramos los codigos proveedor que NO existen
                    if (codigosSinExistencia.length > 0) {
                        const mensaje = (
                            <div>
                                Los siguientes Codigos Proveedor no existen:
                                <ul>
                                    {codigosSinExistencia.map((data, i) => (
                                        <li key={i}>{data.CodigoProveedor}</li>
                                    ))}
                                </ul>
                            </div>
                        )
                        toast.error(mensaje)
                    }

                    // Eliminados del listado de los codigos proveedor que NO existe en la bd
                    Agregar = nuevos
                    .filter(a => codigosExistencia.has(a.CodigoProveedor))
                    .map(a => {
                        const articuloBD = nuevoExisteBD.find(b => b.CodigoProveedor === a.CodigoProveedor)
                        return {
                            ...a,
                            idArticuloInventario: articuloBD ? articuloBD.idArticuloInventario : 0,
                            Nombre: articuloBD ? articuloBD.Nombre : 'Sin Información',
                            NombreCorto: articuloBD ? articuloBD.NombreCorto : 'Sin Información',
                        }
                    })
                    
                } catch (err) {
                    if (err.response) toast.error(err.response.data)
                    else toast.error(ErrorMessages.SinConexion)
                }
            }

            // Arreglo final a sincronizar 
            const sincronizarArticulosInventario = [ ...Agregar, ...eliminados, ...existentes ]

            // Filtrar duplicados por idArticuloInventario
            const vistos = new Set()
            const duplicados = new Set()
            const sincronizarAlmart = sincronizarArticulosInventario.filter(item => {
                const id = item.idArticuloInventario

                    // Ignorar ids inválidos
                    if (!id || id === 0) return true

                    if (vistos.has(item.CodigoProveedor)) {
                        duplicados.add(item.CodigoProveedor)
                        return false
                    }

                    vistos.add(item.CodigoProveedor)
                    return true
            })
            
            // Mostrar toast solo si hay duplicados reales
            if (duplicados.size > 0) {
                const mensaje = (
                    <div>
                        Se encontraron los siguientes Códigos Proveedor duplicados y fueron ignorados:
                        <ul>
                            {[...duplicados].map(id => (
                                <li key={id}>{id}</li>
                            ))}
                        </ul>
                    </div>
                )
                toast.error(mensaje)
            }

            if (sincronizarAlmart.length > 0) {
                WarehouseAPI.SincronizarArticulosInventario(sincronizarAlmart).then(response => {
                    toast.success("La información de los artículos se sincronizó correctamente.")
                }).catch(err => {
                    if (err.response)
                        toast.error(err.response.data)
                    else
                        toast.error(ErrorMessages.SinConexion)
                })
            }

            setState(prev => ({
                ...prev,
                excelData: sincronizarAlmart,
                articulosBase: [...Agregar, ...existentes],
                isLoading: false
            }))

            // Limpiar el input para permitir cargar el mismo archivo o uno nuevo posteriormente
            try { if (inputElement) inputElement.value = '' } catch(e) {}
        }

        reader.onerror = (err) => {
            setState(prev => ({ ...prev, isLoading: false }))
            try { if (inputElement) inputElement.value = '' } catch(e) {}
            toast.error('Error leyendo el archivo. Intenta de nuevo.')
        }

        reader.readAsArrayBuffer(file)
    }

    return (
        <>
            <Modal
                showModal={true}
                modalTitle="Artículos Plantilla"
                width="50%"
                cancel={onClose}
            >
                <div className="card">
                    <div className="card-content">
                        <div className="row" style={{ justifyContent: "center" }}>
                            <div className="columns">
                                <div className="column is-12">
                                    <ExcelFile
                                        filename={`ArticulosBaseInventarios-${new Date().toLocaleDateString('es-MX')}`}
                                        element={
                                            <button className="button is-success" style={{ marginRight: 20 }}>
                                                <span className="file-icon">
                                                    <i className="fa fa-file" />
                                                </span>
                                                <span>Descargar</span>
                                            </button>
                                        }
                                    >
                                        <ExcelSheet data={state.articulosBase} name="articulosBase" >
                                            <ExcelColumn label="CodigoProveedor" value={(articulosBase) => articulosBase.CodigoProveedor} />
                                            <ExcelColumn label="Nombre" value={(articulosBase) => articulosBase.Nombre} />
                                            <ExcelColumn label="NombreCorto" value={(articulosBase) => articulosBase.NombreCorto} />
                                            <ExcelColumn label="Pedido" value={(articulosBase) => articulosBase.Sugerible ? 1 : 0} />
                                            <ExcelColumn label="Inventario" value={(articulosBase) => articulosBase.Inventariable ? 1 : 0} />
                                        </ExcelSheet>
                                    </ExcelFile>
                                    <button onClick={() => setState({...state, showUploadModal: true})} className="button is-success" style={{ marginRight: 20 }}>
                                        <span className="file-icon">
                                            <i className="fa fa-upload" />
                                        </span>
                                        Cargar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <br />

                <div className="card">
                    <div className="card-content">
                        { state.articulosBase.length > 0 ? (
                        <div>
                            <table className="table is-fullwidth">
                            <thead>
                                <tr>
                                    <th>Código Proveedor</th>
                                    <th>Nombre</th>
                                    <th>Pedido</th>
                                    <th>Inventario</th>
                                </tr>
                            </thead>
                            <tbody>
                                {state.pageArticulosBase.map((item) => (
                                <tr key={item.idArticuloInventario}>
                                    <td>{item.CodigoProveedor}</td>
                                    <td>{item.NombreCorto}</td>
                                    <td>
                                        <Field label="" isHorizontal>
                                            <input
                                                type="checkbox"
                                                id={`isSuggestible-${item.idArticuloInventario}`}
                                                name="isSuggestible"
                                                className="switch"
                                                checked={!!item.Sugerible}
                                                onChange={(e) => {
                                                    e.stopPropagation()
                                                    const updatedItem = { ...item, Sugerible: e.target.checked }
                                                    ChangeStatus(updatedItem)
                                                }}
                                            />
                                            <label htmlFor={`isSuggestible-${item.idArticuloInventario}`} />
                                        </Field>
                                    </td>
                                    <td>
                                        <Field label="" isHorizontal>
                                            <input
                                                type="checkbox"
                                                id={`isInventariable-${item.idArticuloInventario}`}
                                                name="isInventariable"
                                                className="switch"
                                                checked={!!item.Inventariable}
                                                onChange={(e) => {
                                                    e.stopPropagation()
                                                    const updatedItem = { ...item, Inventariable: e.target.checked }
                                                    ChangeStatus(updatedItem)
                                                }}
                                            />
                                            <label htmlFor={`isInventariable-${item.idArticuloInventario}`}
                                            />
                                        </Field>
                                    </td>
                                </tr>
                                ))}
                            </tbody>
                            </table>
                        </div>
                        ) : (
                        <NoItems itemName="productos en almacén" />
                        )}

                        {state.articulosBase.length > 0 && (
                            <Pagination
                                items={state.articulosBase}
                                initialPage={1}
                                pageSize={10}
                                onChangePage={handlePageChange}
                            />
                        )}
                    </div>
                </div>

                <Loading isFullscreen={true} isLoading={state.isLoading} width="100px" height="100px" />
            </Modal>
            

            {/* Modal secundario para cargar archivo */}
            {state.showUploadModal && (
                <Modal
                    showModal={true}
                    modalTitle="Cargar archivo Excel"
                    width="50%"
                    cancel={() => setState({...state, showUploadModal: false, excelData: [], nombreArchivo: 'Cargar archivo Excel (.xlsx, .xls)...'})}
                    footer={false}
                >
                    <div className="card">
                        <div className="card-content has-text-centered" style={{ display: "flex", justifyContent: "center", marginTop: "1rem" }}>
                            <div className="file is-boxed is-success" style={{ justifyContent: "center" }}>
                                <label className="file-label">
                                <input
                                    className="file-input"
                                    type="file"
                                    accept=".xlsx, .xls"
                                    onChange={handleFileUpload}
                                />
                                <span className="file-cta">
                                    <span className="file-icon">
                                        <i className="fa fa-upload" />
                                    </span>
                                    <span className="file-label">{state.nombreArchivo}</span>
                                </span>
                                </label>
                            </div>
                        </div>
                    </div>

                    <br />
                    
                    {state.excelData.length > 0 && (
                        <div className="card">
                            <div className="card-content">
                                <div className="table-container" style={{ marginTop: 20 }}>
                                    <table className="table is-striped is-narrow is-hoverable is-fullwidth">
                                        <thead>
                                            <tr>
                                                <th>Código Proveedor</th>
                                                <th>Nombre</th>
                                                <th>Acción</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {state.excelData.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{item.CodigoProveedor}</td>
                                                    <td>{item.NombreCorto}</td>
                                                    <td>{ !!item.IsNew ? 'Nuevo' : (!!item.IsDeleted ? 'Eliminado' : 'Actualizado') }</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    )}

                    <Loading isFullscreen={true} isLoading={state.isLoading} width="100px" height="100px" />
                </Modal>
            )}
        </>
    )
}
